import actionTypes from 'constants/actionTypes'


export const openGraphQueryModal = () => {
  return {
    type: actionTypes.GRAPH_QUERY.OPEN_MODAL
  }
}

export const closeGraphQueryModal = () => {
  return {
    type: actionTypes.GRAPH_QUERY.CLOSE_MODAL
  }
}

export const requestGraphQuery = () => {
  return {
    type: actionTypes.GRAPH_QUERY.REQUEST,
  }
}

export const successGraphQuery = () => {
  return {
    type: actionTypes.GRAPH_QUERY.SUCCESS
  }
}

export const failGraphQuery = () => {
  return {
    type: actionTypes.GRAPH_QUERY.FAIL
  }
}

export const cancelGraphQuery = () => {
  return {
    type: actionTypes.GRAPH_QUERY.CANCEL
  }
}

export const setGraphQueryStatus = (status: string) => {
  return {
    type: actionTypes.GRAPH_QUERY.SET_STATUS,
    payload: status
  }
}
